import React from 'react';
import { Alert, AlertVariant } from '../../../../components/Alert';
import CustomIntlTelInput from '../../../../components/Users/CustomIntlTelInput';
import styles from './AddRiskyIdForm.module.css';

interface BlacklistedMobileNumberFormFieldsProps {
  mobileNumber: string;
  reason: string;
  active: boolean;
  onMobileNumberChange: (value: string) => void;
  onReasonChange: (value: string) => void;
  onActiveChange: (value: boolean) => void;
  onPhoneValidationChange?: (isValid: boolean) => void;
  isMobileNumberDisabled?: boolean;
  showAlert?: boolean;
}

const BlacklistedMobileNumberFormFields: React.FC<BlacklistedMobileNumberFormFieldsProps> = ({
  mobileNumber,
  reason,
  active,
  onMobileNumberChange,
  onReasonChange,
  onActiveChange,
  onPhoneValidationChange,
  isMobileNumberDisabled = false,
  showAlert = false
}) => {
  const handlePhoneNumberChange = (
    isValid: boolean,
    phone: string
  ) => {
    onMobileNumberChange(phone);
    if (onPhoneValidationChange) {
      onPhoneValidationChange(isValid);
    }
  };

  return (
    <>
      <div className="mb-3">
        <label htmlFor="mobile_number" className="form-label"> {/* skipcq: JS-0752 */}
          Mobile Number <span className="text-danger">*</span>
        </label>
        <div className={`${styles.phoneInputWrapper} ${isMobileNumberDisabled ? styles.disabled : ''}`}>
          <CustomIntlTelInput
            value={mobileNumber}
            onPhoneNumberChange={handlePhoneNumberChange}
            placeholder="Enter mobile number"
            isRequired
            id="mobile_number"
          />
        </div>
        <small className="form-text text-muted">
          Enter a valid mobile number
        </small>
      </div>

      <div className="mb-3">
        <label htmlFor="reason" className="form-label"> {/* skipcq: JS-0752 */}
          Reason
        </label>
        <textarea
          id="reason"
          name="reason"
          className={`form-control ${styles.formTextarea}`}
          rows={4}
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          maxLength={255}
          placeholder="Enter reason for blacklisting this mobile number"
          required={false}
        />
        <small className="form-text text-muted">
          {reason.length}/255 characters
        </small>
      </div>

      <div className="mb-3">
        <label htmlFor="active" className="form-label"> {/* skipcq: JS-0752 */}
          Active
        </label>
        <div className={`${styles.activeToggle} ${styles.switchContainer}`}>
          <input
            className={styles.switchInput}
            type="checkbox"
            id="active"
            checked={active}
            onChange={(e) => onActiveChange(e.target.checked)}
            role="switch"
            aria-checked={active}
            aria-label="Toggle active status"
          />
          <label
            aria-hidden="true"
            htmlFor="active"
            className={`${styles.toggleSwitch} ${active ? styles.active : ''}`}>{/* skipcq: JS-0752 */}
            <div className={`${styles.toggleSlider} ${active ? styles.active : ''}`} />
          </label>
        </div>
        <small className="form-text text-muted">
          When inactive, this mobile number will not be blocked
        </small>
      </div>

      {showAlert && (
        <Alert variant={AlertVariant.Pink}>
          Users with this mobile number will not be able to access the product.
        </Alert>
      )}
    </>
  );
};

export default BlacklistedMobileNumberFormFields;